import * as React from 'react';
import logo from '../images/logo.png';
import { LoginMenu } from './api-authorization/LoginMenu';

interface Home {

}

export class TopMenu extends React.Component<{}, Home> {
    constructor(props: any) {
        super(props);

    }

    public render() {
        return (
            <div>
                <div className="top-nav">
                    <div><a href="/"><img className="logo" src={logo}></img></a></div>
                    <LoginMenu></LoginMenu>
                </div>
            </div>
        )
    }
}
